// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import * as strings from "./strings.json";
export { strings };
